/**
 * http链接转卡片消息组件
 * @author lvyajing3
 */
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { connect } from "dva";
import "./index.less";
import { Employee, MessageStatus, SessionType, TextChatMessageExt } from "@/types/chat";
import { MessageSendType, SessionSettingsType } from "@/types/chat/enum";
import ChatState from "@/types/chat/State";
import Link from "@/assets/images/link.png";
import CopyClipboard from "copy-to-clipboard";
import { message as toast } from "antd";
import { useTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import { getTextMessageContent } from "@/components/chat/utils/commonMessageModal";
import Context from "@/components/chat/context";
import ReplyMessage from "@/components/chat/message/ReplyMessage";
import { getRealConfig, judgeHttpCardLinkUrl } from "@/utils/tools";
import MessageCard, { OriginType } from "../message-components/MessageCard";
import {
  convertContentToArray,
  MessageCardType,
  employeeToUid,
  forwardLeaveWord,
  selectedSessionsToForward,
  isShowAlias,
  forwardLimitSessionNum
} from "@/utils/chat/message";
import ShortLink from "../message-components/ShortLink";
import { handleOpenMentionUserInfo } from "@/utils/chat/index";
import { getSelectorSessions } from "@/utils/chat/session";
import { openUserSelectionDefaultModal, openUserSelectionModal } from "@/utils/modals";
import { SelectorMode, UserSelTab } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import config, { ConfigEnum } from "@/config/config";
import chatConfig from "@/components/chat/config";
import { InputPlacement } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal/types";
import { UserModel } from "@/models/user";
import get from "lodash/get";
import { debounce, isString, pick } from "lodash";
import ImService from "@/server/ImService";
import DeeplinkEvent, { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import { shareScheduleAttachment } from "@/api/calendar";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import classNames from "classnames";

interface TextProps {
  message: TextChatMessageExt;
  sessionType: SessionType;
  sendType: MessageSendType;
  beginSend: boolean;
  messageExtend: any;
  userData: UserModel;
  teamConfig: any;
  isforward?: boolean;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
}

type ITextProps = Readonly<TextProps & ChatState>;

function HttpCard(props: ITextProps) {
  const {
    sendType,
    message,
    onReady,
    currentEmployee,
    selectedSession,
    allSessionList,
    sessionMessageMap,
    isforward,
    userData,
    teamConfig
  } = props;
  const { groupRosterIdentity } = React.useContext(Context);
  const { t } = useTranslation("chat");
  const { appRuntimeEnv, focusSDK } = useContext<GlobalContextConfig>(GlobalContext);
  const { im } = appRuntimeEnv;
  const limit_session = getRealConfig(teamConfig, im, "forwardlimit_session") || 10;
  const limit_session_single = getRealConfig(teamConfig, im, "forwardlimit_session_single") || 20;
  const { data } = message as any;
  const isArr = Array.isArray(data);
  const {
    fileName = "内容分享",
    fileContent = "快查看分享的内容吧！",
    webUrl,
    egovWebUrl,
    egovIconUrl,
    iconUrl,
    source
  } = isArr ? data[0].joySpaceLinkDetail : data;
  if (isArr) {
    props.message.content = data[0].joySpaceLinkDetail.content;
  }

  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);

  function handleOpenUrl(e: any) {
    e.stopPropagation();
    e.preventDefault();
    const url = focusSDK.isPrivateNet() && egovWebUrl ? egovWebUrl : webUrl;
    if (!url) {
      return;
    }
    const isOpen = judgeHttpCardLinkUrl(url);
    // console.log('isOpen', isOpen);
    if (!isOpen) {
      const isShowToast = handleCopyUrl(e, true);
      if (isShowToast) {
        toast.success("地址已复制到剪切板，请在浏览器中打开。");
      }
      return;
    }
    window.open(url);
  }
  function handleCopyUrl(event: any, isNotDefaultToast?: boolean) {
    event.stopPropagation();
    event.preventDefault();
    // let userSelection;
    // let str = webUrl;
    // if (typeof window.getSelection === 'function') {
    //     userSelection = window.getSelection();
    // }
    // if (userSelection?.toString()) {
    //     str = userSelection.toString();
    // }
    // if ((str || '').length > (webUrl || '').length) {
    //     str = webUrl;
    // }
    if (webUrl && CopyClipboard(webUrl)) {
      if (isNotDefaultToast) {
        return true;
      }
      toast.success(t("copy-succeeded"));
    } else {
      toast.error(t("copy-failed"));
    }
  }

  // 转发
  function handleForward() {
    // const fixedUsers = getSelectorSessions(allSessionList);
    openUserSelectionDefaultModal(
      {
        title: t("select-session-contacts"),
        // fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        // mode: SelectorMode.forward,
        mode: SelectorMode.user,
        tabs: ["recentIncludeGroup", "groupCanBeSel"],
        tabSort: [{ tab: UserSelTab.recentIncludeGroup, sort: 1 }],
        leaveWordInput: {
          maxLength: chatConfig["forward-leave-max-length"],
          placeholder: t("please-enter-forward-leave"),
          isTextArea: true
        },
        inputPlacement: InputPlacement.bodyRightBottom,
        inputWrapClass: "forward-input-wrap",
        maxSelectedNum: limit_session,
        maxSelectedSingleNum: limit_session_single,
        isForwardMode: true,
        validate(data) {
          return new Promise((resolve, reject) => {
            let list = get(data, "data.result", []);
            const canForward = forwardLimitSessionNum(list, limit_session, limit_session_single);
            if (!canForward) {
              toast.warning(`最多支持选择${limit_session_single}个单聊，${limit_session}个组沟通`);
              return;
            }
            // if (list.length > limit_session) {
            //   toast.error(`最多支持选择${limit_session}个会话`);
            //   return false;
            // }
            const forwardLeave = get(data, "data.leaveWordInputValue", "");
            if (forwardLeave && forwardLeave.length > chatConfig["forward-leave-max-length"]) {
              toast.info(
                t("content over maxLength", {
                  name: "留言",
                  maxLength: chatConfig["forward-leave-max-length"]
                })
              );
              return false;
            }
            resolve();
          });
        }
      },
      (data, close) => {
        doExitAndForward(data, close);
      },
      userData
    );
  }

  const exitAndForward = (options: any, list: any): Promise<boolean> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const imService = ImService.getInstance();
      const sessionId = selectedSession.sessionId;
      let Message: any = message;
      const result = await imService.forwardMessage(sessionId, Message, options);
      if (isString(result) && result === SessionSettingsType.BANNED_POST) {
        toast.warn(t("banned_post_tip"));
        resolve(false);
      }
      if (result) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  };

  const doExitAndForward = debounce(async (data: any, close) => {
    // 等待消息转发完成以后关闭窗口
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    const options = await selectedSessionsToForward(list);
    const status = await exitAndForward(options, list);
    if (status) {
      const forwardLeave = get(data, "data.leaveWordInputValue", "");
      forwardLeave && (await forwardLeaveWord(currentEmployee, options, forwardLeave));
      toast.success(t("forwarding-successful"));
    } else {
      toast.error(t("forwarding-failed"));
    }
    close();
  }, 500);

  const contentArr = useMemo(() => {
    if (message.displayContent && message.displayContent.length > 0) {
      return message.displayContent;
    }
    return convertContentToArray(message.content, (message as any).data);
  }, [message]);

  const getClass = useCallback(() => {
    return classNames({
      "http-link-card-container": true,
      "http-link-card-container-other": sendType === MessageSendType.OTHER,
      "http-link-card-container-noReply": !message.reply
    });
  }, []); // eslint-disable-line

  const desc = fileContent === "快查看分享的内容吧！" ? "请点击卡片，查看内容详情。" : fileContent;
  // 纯http链接转卡片
  return (
    <div className="content">
      <div className={getClass()}>
        {webUrl === props.message.content ? (
          <>
            <ReplyMessage message={message} sendType={sendType} />
            <MessageCard
              origin={source === 1 ? OriginType.Share : OriginType.IM}
              title={fileName}
              desc={desc}
              imageSrc={(focusSDK.isPrivateNet() && egovIconUrl ? egovIconUrl : iconUrl) || Link}
              handleDetail={(e: any) => handleOpenUrl(e)}
              footerChildren={() => {
                if (isforward === true || selectedSession.isSecret) return null;
                return (
                  <div className="http-link-footer">
                    <div className="http-link-footer-container" onClick={handleForward}>
                      {/* <span>复制链接</span> */}
                      <span>转发</span>
                      {/* <IconFont className="icon" type="iconapp_btn_copy" /> */}
                      <IconFont className="icon" type="iconapp_btn_forwarding" />
                    </div>
                  </div>
                );
              }}
            />
          </>
        ) : (
          <>
            <ReplyMessage message={message} sendType={sendType} />
            {contentArr.map((item, index) => {
              return (
                <div key={index} style={{ margin: "1px 0" }}>
                  {item.type === MessageCardType.Text ? (
                    <div
                      onClick={(e) =>
                        handleOpenMentionUserInfo(e, t, {
                          currentEmployee,
                          selectedSession,
                          groupRosterIdentity
                        })
                      }
                      className={`top-box ${selectedSession.isSecret ? "top-box_isSecret" : ""}`}
                      dangerouslySetInnerHTML={{
                        __html: getTextMessageContent(
                          selectedSession,
                          {
                            ...message,
                            content:
                              isShowAlias(selectedSession) && message.atContent
                                ? message.atContent
                                : item.content
                          },
                          currentEmployee
                        ).trim()
                      }}
                    />
                  ) : item.type === MessageCardType.ShortLink ? (
                    <MessageCard
                      origin={source === 1 ? OriginType.Share : OriginType.IM}
                      title={fileName}
                      desc={desc}
                      imageSrc={
                        (focusSDK.isPrivateNet() && egovIconUrl ? egovIconUrl : iconUrl) || Link
                      }
                      handleDetail={(e: any) => handleOpenUrl(e)}
                      footerChildren={() => {
                        if (isforward === true || selectedSession.isSecret) return null;
                        return (
                          <div className="http-link-footer">
                            <div className="http-link-footer-container" onClick={handleForward}>
                              {/* <span>复制链接</span> */}
                              <span>转发</span>
                              {/* <IconFont className="icon" type="iconapp_btn_copy" /> */}
                              <IconFont className="icon" type="iconapp_btn_forwarding" />
                            </div>
                          </div>
                        );
                      }}
                    />
                  ) : (
                    <ShortLink
                      shortLinkItem={item}
                      showTitle={item.type === MessageCardType.HttpTopic}
                    />
                  )}
                </div>
              );
            })}
          </>
        )}
      </div>
    </div>
  );
}

function mapStateToProps({ chat, user: { userData, teamConfig } }: any) {
  const {
    currentEmployee,
    selectedSession,
    connectState,
    allSessionList,
    sessionMessageMap
  } = chat as ChatState;
  return {
    currentEmployee,
    selectedSession,
    connectState,
    allSessionList,
    sessionMessageMap,
    userData: userData ? userData.user : {},
    teamConfig
  };
}
function mapDispatchToProps(dispatch: any) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(HttpCard);
